module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_8017.c78b95de.png";